(function (global) {
  'use strict';

  function findMainVariantOption(options, id) {
    var requested = String(id || '').trim();
    if (!requested) return null;
    return Array.from(options || []).find(function (option) {
      return option && String(option.value) === requested;
    }) || null;
  }

  function findProductOptionButton(buttons, names, value) {
    var expected = String(value || '');
    var allowedNames = (names || []).map(function (name) { return String(name).toLocaleLowerCase('tr-TR'); });
    return Array.from(buttons || []).find(function (button) {
      return button && !button.disabled && button.dataset &&
        allowedNames.includes(String(button.dataset.optionName || '').toLocaleLowerCase('tr-TR')) &&
        String(button.dataset.optionValue || '') === expected;
    }) || null;
  }

  function initialize() {
    var doc = global.document;
    if (!doc || doc.__hanezzaOutfitPageSyncReady) return;
    doc.__hanezzaOutfitPageSyncReady = true;
    var synchronizing = false;

    // The mobile form is the primary source below the product layout breakpoint.
    // Its hidden variant ID must not be overridden by a stale desktop form.
    function pageVariantId() {
      var mobile = doc.querySelector('#product-form-mobile input[name="id"]');
      var desktop = doc.querySelector('#product-form-desktop input[name="id"]');
      var primary = global.innerWidth < 1024 ? mobile : desktop;
      var fallback = global.innerWidth < 1024 ? desktop : mobile;
      return String((primary && primary.value) || (fallback && fallback.value) || '');
    }

    function preferredProductButtons() {
      var mobile = Array.from(doc.querySelectorAll('#product-form-mobile .variant-option'));
      var desktop = Array.from(doc.querySelectorAll('#product-form-desktop .variant-option'));
      return global.innerWidth < 1024 ? mobile.concat(desktop) : desktop.concat(mobile);
    }

    function shouldSyncOutfitWidget(root) {
      if (!root) return false;
      if (root.querySelector('[data-hzcl-shuffle-pilot]')) return true;
      try {
        var rules = JSON.parse(root.dataset.hzclColorRules || '[]');
        return Array.isArray(rules) && rules.length > 0;
      } catch (_) { return false; }
    }

    function mainVariantSelectors() {
      return Array.from(doc.querySelectorAll('[data-hzcl-root]')).filter(shouldSyncOutfitWidget).map(function (root) {
        return root.querySelector('[data-hzcl-main] [data-hzcl-variant]');
      }).filter(Boolean);
    }

    function syncWidgetsFromPage(preferredId) {
      if (synchronizing) return;
      var id = typeof preferredId === 'string' && preferredId ? preferredId : pageVariantId();
      if (!id) return;
      synchronizing = true;
      try {
        mainVariantSelectors().forEach(function (selector) {
          var match = findMainVariantOption(selector.options, id);
          if (!match || selector.value === match.value) return;
          selector.value = match.value;
          selector.dispatchEvent(new global.Event('change', { bubbles: true }));
        });
      } finally { synchronizing = false; }
    }

    function syncPageFromWidget(selector) {
      if (synchronizing) return;
      var variant = selector && findMainVariantOption(selector.options, selector.value);
      if (!variant || variant.disabled) {
        syncWidgetsFromPage();
        return;
      }
      if (pageVariantId() === variant.value) {
        syncWidgetsFromPage();
        return;
      }
      var topButtons = preferredProductButtons();
      var colorButton = findProductOptionButton(topButtons, ['Renk', 'Color'], variant.dataset.color);
      if (!colorButton) {
        syncWidgetsFromPage();
        return;
      }

      synchronizing = true;
      try {
        // A size may be disabled for the OLD color (Pudra/44 sold out),
        // but available in the NEW color (Siyah/44). Change color first,
        // then let the PDP recompute the size buttons before looking for one.
        if (!colorButton.classList.contains('selected')) colorButton.click();
        if (pageVariantId() !== variant.value) {
          var sizeButton = findProductOptionButton(preferredProductButtons(), ['Beden', 'Size'], variant.dataset.size);
          if (sizeButton) sizeButton.click();
        }
      } finally { synchronizing = false; }
      // Do not move the image gallery if the main product did not actually switch.
      if (pageVariantId() === variant.value) syncMobileGallery(colorButton);
      syncWidgetsFromPage();
    }

    function syncMobileGallery(colorButton) {
      if (!colorButton) return;
      var mediaId = colorButton.dataset.imageId;
      var slider = doc.getElementById('mobile-image-slider');
      if (!mediaId || !slider) return;
      var slide = Array.from(slider.querySelectorAll('[data-media-id]')).find(function (el) {
        return String(el.dataset.mediaId) === String(mediaId);
      });
      if (!slide) return;
      slider.scrollLeft = slide.offsetLeft;
      if (typeof slide.scrollIntoView === 'function') {
        slide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
      }
    }

    doc.addEventListener('click', function (event) {
      var button = event.target && event.target.closest &&
        event.target.closest('#product-form-desktop .variant-option, #product-form-mobile .variant-option');
      // The product form's click handler may run later in the same event dispatch.
      // Defer fallback sync until its selected variant ID has been committed.
      if (button) Promise.resolve().then(syncWidgetsFromPage);
    });
    doc.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (target.matches('[data-hzcl-main] [data-hzcl-variant]') &&
          target.closest('[data-hzcl-root]')) {
        syncPageFromWidget(target);
      } else if (target.matches('#product-form-desktop input[name="id"], #product-form-mobile input[name="id"]')) {
        syncWidgetsFromPage();
      }
    });
    // Fired by main-product-custom after it updates ID, price, stock and imagery.
    // One authoritative event keeps desktop and mobile outfit selectors in lockstep.
    doc.addEventListener('hanezza:variant-change', function (event) {
      var id = event && event.detail && String(event.detail.id || '');
      syncWidgetsFromPage(id);
    });
    global.addEventListener('popstate', function () { syncWidgetsFromPage(); });
    doc.addEventListener('shopify:section:load', syncWidgetsFromPage);
    syncWidgetsFromPage();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { shouldSyncOutfitWidget: shouldSyncOutfitWidget, findMainVariantOption: findMainVariantOption,
      findProductOptionButton: findProductOptionButton };
  }
  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
